<div class="cover" #cover [ngClass]="{ 'active': active, 'fadeout': fadeout, 'invisible': invisible }" (click)="onCoverClicked($event)"></div>